import script from "./FooterText.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterText.vue?vue&type=script&setup=true&lang=js"

import "./FooterText.vue?vue&type=style&index=0&id=39d32b59&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d32b59"]])

export default __exports__